import { GetdatafirebaseService } from './../../services/getdatafirebase.service';
import { Component, ElementRef, Injectable, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpRequest, HttpHandler } from '@angular/common/http';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { FirebaseService } from '../../services/firebase.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { defer } from 'rxjs';
import { get } from 'scriptjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
declare var klokantech;
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Observable } from 'rxjs';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { BrdsqlService } from '../../services/brdsql.service';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare const google: any;
declare var $: any;
@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.css']
})
@Injectable()
export class ActionComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('search')
  public searchElementRef: ElementRef;
  currentlat: any;
  currentlng: any;
  uploadPercentage$: Observable<number>;
  coordinates: any;
  coordinatesCenter: any;
  Datacanetrack: any;
  farmerlist: any;
  FormTrackCane: UntypedFormGroup;
  FormTrackActionLand: UntypedFormGroup;
  farmerdata: any;
  keydata: any;
  infordata: any;
  mapinfor: UntypedFormGroup;
  lastSelectedInfoWindow: any;
  maps: any = {};
  orther = false;
  sqldata: any;
  current = false;
  //// actionplan
  actionplanallbrd: any;
  actionplanallZone: any;
  actionplanmaindata: any;
  grade: any;

  ///actionplan end
  selectreadygrow = [
    { text: "ไถเตรียมแล้ว", set: "Y" },
    { text: "ยังไม่ได้ทำเนินการ", set: "N" },
  ]
  selettimes = [
    /*{ name: '6364', year: '2021' },
    { name: '6465', year: '2122' },
    { name: '6566', year: '2223' },
    { name: 'ปี พ.ศ.2566-2567', year: '2324' },
    { name: 'ปี พ.ศ.2567-2568', year: '2425' },*/
    { name: 'ปี พ.ศ.2568-2569', year: '2526' },
  ];
  selectzone = [];
  plantarea;
  update;
  urlimg: string;
  lat;
  lng;
  map: any;
  colorclick = '';
  zoom = 16;
  today;
  year: any;
  constructor(private spinner: NgxSpinnerService, private firebaseService: FirebaseService, private storage: AngularFireStorage, private auth: Authenticationservice, private getdata: GetdatafirebaseService, private brdsql: BrdsqlService
  ) {
    this.maps = [];
    //this.LoadZone();
    let userdata;
    userdata = this.auth.Authention();
    this.supcode = userdata.supcode;
    this.zone = userdata.zonedata;
    this.userlevel = userdata.userlevel;
    //this.getdata.getYear().then((year: any) => {this.year = year.slice(3)}); 


    this.FormTrackCane = new UntypedFormGroup({
      seletzone: new UntypedFormControl(Validators.required),
      seletroot: new UntypedFormControl('', Validators.required),
      selettime: new UntypedFormControl(Validators.required),
      farmercode: new UntypedFormControl('', Validators.required),
      selectyear: new UntypedFormControl('00', Validators.required),
    });

    this.FormTrackActionLand = new UntypedFormGroup({
      landitid: new UntypedFormControl(Validators.required),
      landno: new UntypedFormControl(Validators.required),
      selectdate: new UntypedFormControl(Validators.required),
      lookcaneton: new UntypedFormControl(Validators.required),
      landrate: new UntypedFormControl(),
      dindan: new UntypedFormControl(),
      percenrate: new UntypedFormControl(),
      cemee1: new UntypedFormControl(),
      cemee2: new UntypedFormControl(),
      cemee3: new UntypedFormControl(),
      dolomite: new UntypedFormControl(),
      dindanQ: new UntypedFormControl(),
      cemee1Q: new UntypedFormControl(),
      cemee2Q: new UntypedFormControl(),
      cemee3Q: new UntypedFormControl(),
      fertilizerQ: new UntypedFormControl(),
      dolomiteQ: new UntypedFormControl(),
      weed: new UntypedFormControl(),
      bugandgerm: new UntypedFormControl(),
      repaircane: new UntypedFormControl(),
      takewater: new UntypedFormControl(),
      comment: new UntypedFormControl(''),
      photoland: new UntypedFormControl(),
      fertilizeruse: new UntypedFormControl(),
      leaves: new UntypedFormControl(),
      Exist: new UntypedFormControl(),
      Areaok: new UntypedFormControl(),
      damaged_area: new UntypedFormControl(),
      damaged_rai: new UntypedFormControl(),
    });
  }

  zone;
  supcode;
  userlevel;
  hurl_s = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?'
  ngOnInit(): void {
    console.log('supcode', this.supcode);
    if (this.userlevel === '6') {
      this.orther = true;
    }
    if (navigator) {
      navigator.geolocation.getCurrentPosition(pos => {
        this.lng = +pos.coords.longitude;
        this.lat = +pos.coords.latitude;
      });
    }

    this.selectzone = this.brdsql.supzone;
  }

  /*
  LoadZone() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.selectzone = (res.data.recordset);
        this.spinner.hide();
      }).catch(err => { throw (err) })
    this.spinner.hide();
  }*/


  currentlocation() {
    this.current = !this.current;
    this.coordinatesCenter.lng = this.lng;
    this.coordinatesCenter.lat = this.lat;
  }

  DeleteformDataid(dataid) {
    if (confirm('ต้องการลบข้อมูลหรือไม่?')) {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var myArr = this.responseText.split("|");
          if (myArr[0] == "Y") {
            alert('(^-^) บันทึกข้อมูลเรียบร้อยแล้ว')
          } else { // alert('!! การอัพเดตสำเร็จ')
          }
        }
      };
      xmlhttp.open("post", "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/deleteAudit?dataid=" + dataid, true);
      xmlhttp.send();
      alert('ลบข้อมูลเรียบร้อบแล้วค่ะ');
      this.Showdatafromformactionland();
    }
    else { console.log('no update'); }
  }

  onFileUpload(files: FileList): void {
    let landitid = (<HTMLInputElement>document.getElementById('landitid')).value;
    console.log(files);
    const file = files[0]; // get single file
    const path = `brr_smartfarm/photos/formtrackactionland/${this.supcode}/${file.name}`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, file);
    this.uploadPercentage$ = this.storage
      .upload(path, file)
      .percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          ref
            .getDownloadURL()
            .toPromise()
            .then((url) => {
              // const photo: Photo = { url };
              // console.log(url);
              // this.urlimg = = url;

              // this.firestore.collection('photos').doc(this.truckq).set(photo);
            });
        })
      )
      .subscribe();

    let bucket = 'brr-farmluck.appspot.com'
    let url_pubilc = 'https://storage.googleapis.com/' + bucket + '/brr_smartfarm/photos/formtrackactionland/' + this.supcode + '/' + file.name;
    console.log(url_pubilc);
    this.urlimg = url_pubilc;
  }

  GenPDF(grade, intLandNo, canetype, landvalue, supzone, route, farmerdata, ck_hardSoilBlast, ck_AmountFertilizer, ck_Dolomite, ck_AmountNatural, ck_GerminationP, ck_weed, ck_Disease, ck_Groove) {
    // console.log(farmerdata);
    var textck_hardSoilBlast = 'N';
    var textck_AmountFertilizer = 'N';
    var textck_Dolomite = 'N';
    var textck_hardSoilBlast = 'N';
    var textck_AmountNatural = 'N';
    var textck_GerminationP = 'N';
    var textck_weed = 'N';
    var textck_Disease = 'N';
    var textck_Groove = 'N';
    if (ck_hardSoilBlast == 1) { textck_hardSoilBlast = 'Y'; }
    if (ck_AmountFertilizer == 1) { textck_AmountFertilizer = 'Y'; }
    if (ck_Dolomite == 1) { textck_Dolomite = 'Y'; }
    if (ck_AmountNatural == 1) { textck_AmountNatural = 'Y'; }
    if (ck_GerminationP == 1) { textck_GerminationP = 'Y'; }
    if (ck_weed == 1) { textck_weed = 'Y'; }
    if (ck_Disease == 1) { textck_Disease = 'Y'; }
    if (ck_Groove == 1) { textck_Groove = 'Y'; }
    let date = new Date();
    const result = date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    })
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/getfmdata?fmcode_b1=' + farmerdata;
    fetch(url)
      .then(res => res.json())
      .then((out: any) => {
        const data = out.recordsets[0];
        this.farmerdata = data;
        return this.farmerdata;
      })
      .catch(err => { throw err });
  }

  THtoLocalstring(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  /// กิจกรรมแปลง
  GetTarget() {
    let time = (new Date(this.FormTrackCane.get('selettime').value).getTime() / 1000);
    const date = new Date(this.FormTrackCane.get('selettime').value)
    let day = date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    this.today = day;
    this.spinner.show();
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/supervisMonitorMay2021ByDate?lastdate=' + time;
    axios.get(url)
      .then((res: any) => {
        const data = res.data.recordsets[0];
        let allbrd = data.filter(element => element.Partcode == "BRD")
        let Zone = data.filter(element => element.supcode == "Z" && element.Partcode !== "BRD")
        // let Supsum = data.filter(element => element.SUPNAME ==="*รวมนสส." && element.Partcode !=="BRD" )
        let alldata = data.filter(element => element.Partcode !== "BRD" && element.supcode !== "Z")
        this.actionplanallbrd = allbrd;
        this.actionplanallZone = Zone;
        this.actionplanmaindata = alldata;
        // console.log(alldata)

      })
      .catch(err => { throw err });



    setTimeout(() => {
      this.spinner.hide();
    }, 5000);
  }

  /// เกรดแปลง
  GetGradePlant() {
    // console.log('data Grade :TEST');
    let time = (new Date(this.FormTrackCane.get('selettime').value).getTime() / 1000);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/intro_groupAAAsupcode_6465ByDate?lastdate=" + time;
    this.spinner.show();
    axios.get(url)
      .then(res => {
        const data = res.data.recordsets[0];
        // let allbrd = data.filter(element => element.Partcode =="BRD")
        this.grade = data;
        // console.log(alldata)
      })
      .catch(err => { throw err });
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);

  }

  GetFarmerList() {
    let zone = this.FormTrackCane.get('seletzone').value;
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/fmInzone?supzone=' + zone;
    axios.get(url).then(res => {
      const data = res.data.recordsets[0];
      this.farmerlist = data;
    }).catch(err => { throw err });
  }

  compareNumbers(a, b) {
    return a - b;
  }



  data_map = [];
  all_roots = [];
  getMap() {
    let root = this.FormTrackCane.get('seletroot').value || '';
    let zone = this.FormTrackCane.get('seletzone').value || '';
    let year = this.FormTrackCane.get('selectyear').value || '';
    if (year === '') { alert('กรุณาเลือกปีก่อน'); }
    //else if (root == null || root === '' || zone == null || zone === '') { alert('กรุณาระบุ โซน / รูทก่อนค้นหา'); }
    else {
      this.spinner.show();
      console.log('root zone year :', root, zone, year);
      this.firebaseService.getmapByzone(year, zone)
        .then((maps: any) => {
          this.spinner.hide();
          if (maps.length > 0) {
            this.data_map = maps;
            console.log('mapFirebase', maps);
            //this.maps = maps;
            let all_roots = [...new Set(maps.map(function (elem) { return (elem.DetailPlant.Root) }))].sort(this.compareNumbers);
            this.all_roots = all_roots;
            console.log('alll_root', all_roots);
            //setTimeout(() => { }, 1000);
          }
          else {
            alert('ข้อมูลที่เลือกไม่พบข้อมูล');
          }

          // return this.maps;
          // console.log(this.maps);
        });
    }
  }

  loading: boolean[] = [false, false, false, false, false, false]
  select_zone() {
    let zone = this.FormTrackCane.get('seletzone').value || '';
    let year = this.FormTrackCane.get('selectyear').value || '';
    if (year === '') { alert('กรุณาเลือกปีก่อน'); }
    //else if (root == null || root === '' || zone == null || zone === '') { alert('กรุณาระบุ โซน / รูทก่อนค้นหา'); }
    else {
      this.loading[1] = true;
      let url = this.hurl_s + `s=*&f=[dbintechgen3].[dbo].[v_route_zone]&w=CaneYearId='${year}'and [ZoneId]='${zone}'`;
      axios.get(url).then(res => {
        this.loading[1] = false;
        const data = res.data;
        this.all_roots = data;
      }).catch(err => { throw err });
    }
  }

  select_root = [];

  s_root_1() {
    let root = this.select_root.map(String).map(v => `'${v}'`).join(",");;
    console.log('root:', root)
    let zone = this.FormTrackCane.get('seletzone').value || '';
    let year = this.FormTrackCane.get('selectyear').value || '';
    if (year === '') { alert('กรุณาเลือกปีก่อน'); }
    //else if (root == null || root === '' || zone == null || zone === '') { alert('กรุณาระบุ โซน / รูทก่อนค้นหา'); }
    else {
      this.loading[2] = true;
      let url = this.hurl_s + `s=*&f=[dbintechgen3].[dbo].[v_areas_kml]&w=CaneYearId='${year}'and[ZoneId]='${zone}'and[route]in(${root})`;
      axios.get(url).then(res => {
        this.loading[2] = false;
        const data = res.data;
        let data2 = data.map(item => {
          return {
            ...item,
            point: JSON.parse(item.point),
            coordinates: JSON.parse(item.coordinates),
            //plantDate: item.plantDate.toISOString().split('T')[0] || ''
            //plantDate2: item.plantDate
          };
        });
        if (data2.length > 0) {
          const latitudes = data2.map(m => m.point.lat);
          const longitudes = data2.map(m => m.point.lng);
          // หาค่าเฉลี่ยของ lat/lng ทั้งหมด
          this.latlong.lat = latitudes.reduce((a, b) => a + b, 0) / latitudes.length;
          this.latlong.long = longitudes.reduce((a, b) => a + b, 0) / longitudes.length;
        }

        this.maps = data2;
      }).catch(err => { throw err });
    }
  }
  s_root() {
    let sr = this.select_root;
    //let root = this.FormTrackCane.get('seletroot').value || '';
    this.maps = this.data_map.filter(el => sr.includes(el.DetailPlant.Root));
    console.log('s_map', this.maps);
    this.keydata = this.maps.key;
    this.plantarea = this.maps.AreaPre;
    this.coordinates = this.maps[0].coordinates
    this.coordinatesCenter = this.maps[0].coordinatesCenter
    this.update = new Date(this.maps[0].updDt).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    })
  }
  selectAllChecked = false;

  toggleSelectAll(): void {
    if (this.selectAllChecked) {
      let roots = this.all_roots;
      this.select_root = roots.map(item => item.route);
    } else {
      this.select_root = [];
    }
  }

  selectedItem: any = null;
  latlong = { lat: 0, long: 0 }

  getinforwindows(data, infoWindow) {
    console.log(data);
    if (infoWindow == this.lastSelectedInfoWindow) {
      return;
    }
    if (this.lastSelectedInfoWindow != null) {
      try {
        this.lastSelectedInfoWindow.close();
      } catch { } //in case if you reload your markers
    }
    this.lastSelectedInfoWindow = infoWindow;
    this.zoom = 25;
    this.selectedItem = data;
    // this.colorclick = "blue";
    /*
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/getlandnobyitid?itid=' + key + '';  
    axios.get(url)
      .then(res => {
        const data = res.data.recordsets[0];
        var itid = res.data.recordset[0].itid;
        var landno = res.data.recordset[0].intlandno;
        var yearid = res.data.recordset[0].year;
        $('#itid').val(itid.toString());
        $('#landno').val(landno.toString());
        $('#yearid').val(yearid.toString());
        this.infordata = data;
      })
      .catch(err => { throw err });
      */

  }

  LoaddataTrackCaneLand() {
    let code = (this.FormTrackCane.get('farmercode').value).substring(10, 0);;
    let zone = this.FormTrackCane.get('seletzone').value;
    // console.log(root+zone);
    // window.location.href = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/gradeCP6465?supzone='+zone+'&fmcode='+ code +'';
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/gradeCP6465?supzone=' + zone + '&fmcode=' + code + '';
    console.log(code + zone);
    this.spinner.show();
    axios.get(url)
      .then(res => {
        const data = res.data.recordset;
        if (data.length == 0) {
          alert("ยังไม่มีข้อมูลชาวไร่ชื่อนี้");
        }
        else { this.Datacanetrack = data; }
      })
      .catch(err => { throw err });
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);

  }

  mapReady(event: any) {
    // this.map = event;
  }

  public mapLoad(map) {
    this.renderGeolocationControl(map);
  }

  renderGeolocationControl(map) {
    get('https://cdn.klokantech.com/maptilerlayer/v1/index.js', () => {
      // const geoloccontrol = new klokantech.GeolocationControl(map, 20);
      // new klokantech.GeolocationControl(map, 18);
      var geoloccontrol = new klokantech.GeolocationControl(map, 20);
      console.log(geoloccontrol);
    });
  }

  // โหลดข้อมูลกิจกรรมแปลง
  datacolum: string[] = ['Daterec', 'route', 'intlandno', 'fmcode', 'fmname', 'landvalue', 'dateaudit', 'ton1', 'Comment', 'action'];
  newsql;
  Showdatafromformactionland() {
    let year = this.FormTrackCane.get('selectyear').value;
    this.spinner.show();
    //let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_auditData_w?yearid='+year+'&auditor='+ this.supcode;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].vw_audit&w=yearid='${year}'and[auditor]='${this.supcode}'`;
    axios.get(url).then(res => {
      this.spinner.hide();
      const data = res.data;
      data.sort(function (a, b) { return b.DataId - a.DataId });
      this.sqldata = data;
      this.newsql = new MatTableDataSource(data);
      this.paginator.length = res.data.length;
      this.paginator.pageSize = 10;
      this.newsql.sort = this.sort;
      this.newsql.paginator = this.paginator;
    }).catch(err => { throw err });
  }
  Filterby(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.newsql.filter = filterValue.trim().toLowerCase();;
    if (this.newsql.paginator) {
      this.newsql.paginator.firstPage();
    }
  }
  //  บันทุกข้อมูลกิจกรรมแปลง
  SubmitData() {
    let fta = this.FormTrackActionLand.value
    console.log('FormTrackActionLand : ', fta);

    let img = this.urlimg || '';
    let year = this.FormTrackCane.get('selectyear').value || '';
    let landitid = (<HTMLInputElement>document.getElementById('landitid')).value;
    let landno = (<HTMLInputElement>document.getElementById('landno')).value;
    let selectdate = fta.selectdate || '';
    let lookcaneton = fta.lookcaneton || '';
    let comment = fta.comment || '';
    let photoland = fta.photoland || '';

    // เงื่อนไขใหม่ด้านบน
    let landrate = fta.landrate;
    let percenrate = fta.percenrate;

    let dindan = fta.dindan || '';
    let dindanQ = fta.dindanQ || '';
    let cemee1 = fta.cemee1 || '';
    let cemee1Q = fta.cemee1Q || '';
    let cemee2 = fta.cemee2 || '';
    let cemee2Q = fta.cemee2Q || '';
    let cemee3 = fta.cemee3 || '';
    let cemee3Q = fta.cemee3Q || '';
    let dolomite = fta.dolomite || '';
    let dolomiteQ = fta.dolomiteQ || '';
    let fertilizerQ = fta.fertilizerQ || '';

    let weed = fta.weed || '';
    let bugandgerm = fta.bugandgerm || '';
    let repaircane = fta.repaircane || '';
    let takewater = fta.takewater || '';
    let leaves = fta.leaves || '';
    let damaged_area = fta.damaged_area || '';
    let damaged_rai = fta.damaged_rai || 0;
    let Areaok = fta.Areaok || '';
    let Exist = fta.Exist || '';

    let fertilizeruse = fta.fertilizeruse;

    let margin = '';
    let textcomment = '';
    if (comment === '') { textcomment = ''; } else if (comment !== '') { textcomment = comment; }
    if (fertilizeruse === 'Y') { margin = 'Y'; }
    else if (fertilizeruse === 'Y' && leaves === 'H') { margin = 'Y'; }
    else if (fertilizeruse === 'N' && leaves === 'H') { margin = 'H'; }
    else if (fertilizeruse === null) { margin = ''; }
    else { margin = 'N'; }

    if (selectdate === '') { alert('กรุณาเลือกวันที่') }
    else if (confirm('ต้องการบันทึกข้อมูลหรือไม่?')) {
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/inserttoaudit?"
        + "Auditor='" + this.supcode + "'"
        + "&itid='" + landitid + "'"
        + "&intlandno='" + landno + "'"
        + "&DateAudit='" + selectdate + "'"
        + "&yearid='" + year + "'"
        + "&Ton1=" + lookcaneton
        + "&Groove=" + landrate
        + "&hardSoilBlast='" + dindan + "'"
        + "&hardSoilBlastQ='" + dindanQ + "'"
        + "&chemical1='" + cemee1 + "'"
        + "&chemical1Q='" + cemee1Q + "'"
        + "&chemical2='" + cemee2 + "'"
        + "&chemical2Q='" + cemee2Q + "'"
        + "&chemical3='" + cemee3 + "'"
        + "&chemical3Q='" + cemee3Q + "'"
        + "&dolomite='" + dolomite + "'"
        + "&dolomiteQ='" + dolomiteQ + "'"
        + "&organic='" + margin + "'"
        + "&organicQ='" + fertilizerQ + "'"
        + "&Pccane=" + percenrate
        + "&Canerepair='" + repaircane + "'"
        + "&Weed='" + weed + "'"
        + "&Insect='" + bugandgerm + "'"
        + "&Areaok='" + Areaok + "'"
        + "&Exist='" + Exist + "'"
        + "&damaged_area='" + damaged_area + "'"
        + "&damaged_rai=" + damaged_rai

        + "&getwater='" + takewater + "'"
        + "&Comment='" + textcomment + "'"
        + "&Filepic='" + img + "'";
      //
      //console.log('url : ', url);

      axios.post(url).then(res => {
        if (res.data.rowsAffected) {
          alert('บันทึกข้อมูลเรียบร้อย ^_^!')
          this.FormTrackActionLand.reset();
        };
        if (res.data.code) { alert('ไม่สามารถบันทึกข้อมูลได้') };
      }).catch(err => { console.log(err) })
    }
    else {
      console.log('no update');
    }
    this.Showdatafromformactionland();
    (<HTMLInputElement>document.getElementById('lookcaneton')).value = '';
    (<HTMLInputElement>document.getElementById('landrate')).value = '';
    (<HTMLInputElement>document.getElementById('percenrate')).value = '';
    $('input[type="radio"]').prop('checked', false);
    this.FormTrackActionLand.controls['comment'].setValue('');
    this.FormTrackActionLand.controls['photoland'].setValue('');
    $("#comment").val("");
    $("#photoland").val('');
    this.urlimg = '';
  }

  showmodal() {
    ($('#exampleModal') as any).modal('toggle');
  }

  showimg(imgsrc) {
    $('#photourl').attr('src', imgsrc);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return defer(() => {
      const key = req.urlWithParams;
      console.time(key);
      return next.handle(req).pipe(finalize(() => {
        console.timeEnd(key);
      }));
    });
  }

  s_itid;
  open_menu(id = 0, itid) {
    this.s_itid = itid;
    if (id == 1) {
      $("#show_data").modal('show');
    }
    else if (id == 2) {
      $("#--").modal('show');
    }
    console.log('s_itid', itid);
  }

  ngOnDestroy() {
    this.newsql = null;
    this.sqldata = null;
    this.Datacanetrack = null;

    this.maps = [];
    this.keydata = null;
    this.plantarea = null;
    this.coordinates = null;
    this.coordinatesCenter = null;
    this.update = null;
    this.farmerlist = null;
  }
}

